let underMaintenanceInterval
export default function(ctx) {
  const routeName = 'under-maintenance'

  underMaintenanceInterval = setInterval(() => {
    const featureFlagMaintenance =
      ctx.store?.state['feature-flag']?.featureFlagMaintenance

    if (featureFlagMaintenance) {
      const startDate = featureFlagMaintenance?.startDate
      const endDate = featureFlagMaintenance?.endDate
      const startTime = featureFlagMaintenance?.startTime
      const endTime = featureFlagMaintenance?.endTime

      const [yearStart, monthStart, dayStart] = startDate?.split('-')
      const [hourStart, minuteStart, secondStart] = startTime?.split(':')

      const [yearEnd, monthEnd, dayEnd] = endDate?.split('-')
      const [hourEnd, minuteEnd, secondEnd] = endTime?.split(':')

      const currentDate = new Date()

      const combinedStartDate = new Date(
        yearStart,
        monthStart - 1,
        dayStart,
        hourStart,
        minuteStart,
        secondStart
      )

      const combinedEndDate = new Date(
        yearEnd,
        monthEnd - 1,
        dayEnd,
        hourEnd,
        minuteEnd,
        secondEnd
      )

      if (combinedStartDate <= currentDate && combinedEndDate >= currentDate) {
        if (ctx?.app?.router?.currentRoute?.name !== routeName) {
          const language = ctx?.$storage?.getUniversal('language') || 'en'
          clearInterval(underMaintenanceInterval)

          return ctx?.app?.router?.push({
            name: 'under-maintenance',
            query: { status: 'overview', preferred_language: language }
          })
        }
      } else if (ctx?.app?.router?.currentRoute?.name === routeName) {
        const language = ctx?.$storage?.getUniversal('language') || 'en'
        clearInterval(underMaintenanceInterval)
        return ctx?.app?.router?.push({
          name: 'launcher',
          query: { status: 'overview', preferred_language: language }
        })
      }
    }
  }, 1000)
}
